//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters, mapMutations } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import variablesCard from "@/components/Diagrams/variables-card.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";

export default {
    components: {
        AQModal,
        variablesCard,
        AQButton,
        AQAvatar,
        AQChip,
        AQListBtn,
        AQCheckbox
    },
    props: {
        uuid: {
            type: String,
            default: ""
        },
        elementIndex: {
            type: Number,
            default: 0
        },
        fromAssigTab: {
            type: Boolean,
            default: false
        },
        fromAppMatrix: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object,
            default() {
                return {};
            }
        },
        readonly: {
            type: Boolean
        },
        addNewButtonText: {
            type: String,
            default: ""
        },
        initialValues: {
            type: Boolean
        },
        ruleLevel: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modalOpened: false,
            showSave: false,
            users: null,
            dirty: false,
            hover: null,
            separateTask: false,
            showCheckbox: false,
            copyComputedValue: {},
            hideListBtns: ["edit", "more", "copy", "download"]
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData", "selectedPluginCode", "diagramConfigData", "selectedPluginUuid", "getParallelHTCheckbox"]),
        ...mapGetters("admin", ["roleList", "userList"]),
        hasPrimary() {
            return {
                label: this.$t("generic.done"),
                disabled: !this.showSave
            };
        },
        computedValue: {
            get() {
                const defaultObject = {
                    user: [],
                    role: [],
                    model: [],
                    variable: [],
                    freeText: [],
                    dataTextList: []
                };

                if (this.users) {
                    return this.users;
                } if (this.value) {
                    return this.value;
                }
                return defaultObject;
            },
            set(v) {
                this.users = v;
                this.showSave = JSON.stringify(this.copyComputedValue) !== JSON.stringify(this.users);
            }
        },
        getChipProps() {
            return {
                fontSize: 8,
                fontWeight: 500,
                height: 18,
                lineHeight: 14,
                fromInnerMenu: true
            };
        },
        dynamicAvatarSize() {
            return this.fromAssigTab ? 20 : 32;
        },
        selectedUsers() {
            const vm = this;
            const users = [];

            if (!this.value) {
                return [];
            }

            const source = this.value || {};
            let userCount = 0; let groupCount = 0; let
                modCount = 0;
            if (source.user) {
                source.user.forEach(selected => {
                    let userFound = false;
                    vm.userList.forEach(user => {
                        if (selected === user.id) {
                            let currentName = user.firstName || "";
                            if (user.lastName) {
                                currentName = `${currentName} ${user.lastName}`;
                            }
                            users.push({
                                name: currentName.trim(),
                                email: user.email,
                                type: "USR",
                                color: "positive",
                                id: user.id,
                                systemType: user.type,
                                status: user.status
                            });
                            userCount++;
                            userFound = true;
                        }
                    });

                    if (!userFound) {
                        users.push({
                            name: this.$t("generic.notFound", { id: selected }),
                            type: "USR",
                            color: "positive",
                            canDelete: true
                        });
                        userCount++;
                    }
                });
            }

            if (source.role) {
                let roleFound = false;
                source.role.forEach(selected => {
                    vm.roleList.forEach(role => {
                        if (selected === role.code || selected === role.id) {
                            users.push({
                                active: role.active,
                                name: role.name,
                                type: "GRU",
                                color: "primary",
                                code: role.code,
                                id: role.id,
                                nrOfGroups: role.members[0].nrOfGroups,
                                nrOfUsers: role.members[0].nrOfUsers
                            });
                            groupCount++;
                            roleFound = true;
                        }
                    });

                    if (!roleFound) {
                        users.push({
                            name: this.$t("generic.notFound", { id: selected }),
                            type: "GRU",
                            color: "primary",
                            canDelete: true

                        });
                        groupCount++;
                    }
                });
            }

            if (source.variable) {
                source.variable.forEach(selected => {
                    users.push({
                        name: selected,
                        type: "VAR",
                        color: "info"
                    });
                    modCount++;
                });
            }

            if (source.model) {
                source.model.forEach(selected => {
                    users.push({
                        name: selected,
                        type: "MOD",
                        color: "secondary"
                    });
                    modCount++;
                });
            }

            if (source.freeText) {
                source.freeText.forEach(selected => {
                    users.push({
                        name: selected,
                        type: "FREE",
                        color: "secondary"
                    });
                });
            }

            if (source.dataTextList) {
                source.dataTextList.forEach(selected => {
                    users.push({
                        name: selected,
                        type: "DATA",
                        color: "secondary"
                    });
                });
            }

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.showCheckbox = !!(userCount > 1 || groupCount || modCount);

            return users;
        },
        isExternalTask() {
            return this.selectedPluginCode === "EXTERNAL_PLUGIN";
        },
        showUsers() {
            return !this.isExternalTask;
        },
        showDataText() {
            return this.isExternalTask && !this.selectedPluginConfigData.dynamicExternalTask;
        },
        showDynamicDataText() {
            return this.isExternalTask && this.selectedPluginConfigData.dynamicExternalTask;
        },
        showFreeText() {
            return this.isExternalTask && !this.selectedPluginConfigData.dynamicExternalTask;
        },
        showVariables() {
            return !this.isExternalTask || this.showFreeText;
        },
        showDataModel() {
            return !this.isExternalTask;
        },
        defaultTab() {
            if (this.showFreeText) {
                return "freeText";
            } if (this.showDynamicDataText) {
                return "dataText";
            }
            return "users";
        }
    },
    watch: {
        "users.user": {
            handler(newVal) {
                this.dirty = newVal && this.users.user.length;
            },
            deep: true
        },
        showCheckbox: {
            handler(newVal) {
                if (!newVal) {
                    this.$store.commit("diagrams/setParallelHTCheckbox", false);
                    this.separateTask = this.getParallelHTCheckbox;
                }
            }
        },
        separateTask: {
            handler(newVal) {
                this.$store.commit("diagrams/setParallelHTCheckbox", newVal);
                const localData = JSON.parse(JSON.stringify(this.diagramConfigData));
                if (this.selectedPluginUuid && localData) {
                    localData.content.forEach(el => {
                        if (el.uuid === this.selectedPluginUuid) {
                            el.multiple = newVal;
                            this.$store.commit("diagrams/diagramConfigData", localData);
                        }
                        return false;
                    });
                }
            }
        }
    },
    created() {
        this.$store.dispatch("admin/getRoleList");
        this.$store.dispatch("admin/getUsersList");
        const localData = JSON.parse(JSON.stringify(this.diagramConfigData));
        if (this.selectedPluginUuid && localData) {
            localData.content.forEach(el => {
                if (el.uuid === this.selectedPluginUuid) {
                    if (el.multiple) {
                        this.separateTask = el.multiple;
                    } else {
                        this.separateTask = false;
                    }
                }
                return false;
            });
        }
        this.$store.commit("diagrams/setParallelHTCheckbox", this.separateTask);
    },
    methods: {
        ...mapMutations("diagrams", ["setParallelHTCheckbox"]),
        action(action) {
            if (action === "primary") {
                this.$emit("input", this.users);
                this.hide();
            } else if (action === "close") {
                if (this.dirty) {
                    this.dirty = false;
                } else {
                    this.hide();
                }
            }
        },
        openModal() {
            this.copyComputedValue = { ...this.computedValue };
            this.modalOpened = true;
        },
        setInnerContent(className) {
            const classArr = className.split(".");
            // const lastElement = classArr.pop();
            const innerContent = classArr[0];
            return innerContent;
        },
        setContent(fullName) {
            return fullName.split(".").pop();
        },
        addBinIcon(user) {
            this.hover = user;
        },
        removeBinIcon() {
            this.hover = null;
        },
        setItemType(item) {
            let type;
            if (item.type === "GRU") {
                if (item.sourceType === "AD") {
                    type = "externalGroup";
                } else if (item.systemType === "APPLICATION") {
                    type = "applicationSpecific";
                } else {
                    type = "platform";
                }
            } else if (item.type === "USR") {
                if (item.systemType === "TOAUTHUSR") {
                    type = "systemExternalUser";
                } else if (item.systemType === "TSYS") {
                    type = "systemInternalUser";
                } else {
                    type = (item.sourceType === "AD" || item.systemType === "TSAMLUSR" || item.systemType === "TOPENIDUSR") ? "externalUser" : "userPlatform";
                }
            }
            return type;
        },
        setImage(user) {
            return user && (user.avatar || user.avatarPath) ? `/identity/tenants/users/image/${user.id}/s` : null;
        },
        hide() {
            this.showSave = false;
            this.users = null;
            this.modalOpened = false;
        },
        deleteUser(data) {
            if (data.type === "USR") {
                const index = this.value.user.findIndex(usr => usr === data.id);

                // eslint-disable-next-line vue/no-mutating-props
                this.value.user.splice(index, 1);
            }
            if (data.type === "GRU") {
                const index = this.value.role.findIndex(usr => usr === data.id || usr === data.code);

                // eslint-disable-next-line vue/no-mutating-props
                this.value.role.splice(index, 1);
            }
            if (data.type === "VAR") {
                const index = this.value.variable.indexOf(data.name);
                // eslint-disable-next-line vue/no-mutating-props
                this.value.variable.splice(index, 1);
            }
            if (data.type === "MOD") {
                const index = this.value.model.indexOf(data.name);
                // eslint-disable-next-line vue/no-mutating-props
                this.value.model.splice(index, 1);
            }
        }
    }
};
